import React from "react";
import { Checkbox } from "@/components/ui/checkbox";

const ACTIONS = ["view", "create", "edit", "approve", "delete"];

// Module × action grid. `allowed` (optional) limits which boxes can be ticked.
export function PermissionMatrix({ modules, value, onChange, allowed, testid = "permission-matrix" }) {
  const toggle = (p) => onChange(value.includes(p) ? value.filter((x) => x !== p) : [...value, p]);
  const toggleRow = (m) => {
    const ps = m.actions.map((a) => `${m.key}.${a}`).filter((p) => !allowed || allowed.includes(p));
    const all = ps.every((p) => value.includes(p));
    onChange(all ? value.filter((x) => !ps.includes(x)) : [...new Set([...value, ...ps])]);
  };
  return (
    <div className="overflow-x-auto rounded-xl border border-[#E5E0D8] bg-white" data-testid={testid}>
      <table className="w-full min-w-[560px] text-sm">
        <thead className="bg-[#FAF8F5] text-left text-xs uppercase tracking-wider text-stone-400">
          <tr><th className="px-3 py-2">Area</th>{ACTIONS.map((a) => <th key={a} className="px-2 py-2 text-center">{a}</th>)}</tr>
        </thead>
        <tbody className="divide-y divide-[#F0ECE1]">
          {modules.map((m) => (
            <tr key={m.key}>
              <td className="px-3 py-2"><button type="button" onClick={() => toggleRow(m)} className="text-left font-medium text-stone-700 hover:text-[#0D5C3A]" data-testid={`perm-row-${m.key}`}>{m.label}</button></td>
              {ACTIONS.map((a) => {
                const p = `${m.key}.${a}`;
                if (!m.actions.includes(a)) return <td key={a} className="text-center text-stone-200">—</td>;
                const disabled = allowed && !allowed.includes(p);
                return (
                  <td key={a} className="px-2 py-2 text-center">
                    <Checkbox data-testid={`perm-${m.key}-${a}`} checked={value.includes(p)} disabled={disabled} onCheckedChange={() => toggle(p)} />
                  </td>
                );
              })}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
